import { api, get, post } from '../../service';
import { DIALOG_ADD } from '../../libs/enum';

const defaultForm = () => ({
    agentId: 0,
    name: '',
    mobile: '',
    city: [],
    address: '',
});
const defaultState = () => ({
    dialog: {
        visible: false,
        type: DIALOG_ADD,
    },
    authDetailDialog: {
        visible: false,
    },
    form: defaultForm(),
    search: {
        size: 10,
        page: 1,
        key: '',
    },
    total: 0,
    agents: [],
    authDetail: [],
});

const moduleAgent = {
    namespaced: true,
    state: defaultState(),
    actions: {
        resetState({ commit }) {
            commit('resetState');
        },
        async getAgents({ commit, state }) {
            const res = await post(api.agent.list, state.search);
            commit('changeAgents', res);
        },
        async searchAgents({ commit, state }) {
            const res = await post(api.agent.search, state.search);
            commit('changeAgents', res);
        },
        async addAgent({ commit, dispatch, state }) {
            const { agentId, name, mobile, city, address } = state.form;
            const params = {
                agentId,
                name,
                mobile,
                location: `${city.toString()},${address}`,
            };
            await post(api.agent.add, params);
            commit('changeDialog', { visible: false });
            dispatch('getAgents');
        },
        async editAgent({ commit, dispatch, state }) {
            const { agentId, name, mobile, city, address } = state.form;
            const params = {
                agentId,
                name,
                mobile,
                location: `${city.toString()},${address}`,
            };
            await post(api.agent.edit, params);
            commit('changeDialog', { visible: false });
            dispatch('getAgents');
        },
        async enableAgent({ dispatch }, data) {
            await post(api.agent.enable, data);
            dispatch('getAgents');
        },
        changeDialog({ commit }, data) {
            commit('changeDialog', data);
        },
        changeForm({ commit }, data) {
            commit('changeForm', data);
        },
        changeSearch({ commit, dispatch }, data) {
            commit('changeSearch', data);
            dispatch('searchAgents');
        },
        changeAuthDetailDialog({ commit }, data) {
            commit('changeAuthDetailDialog', data);
        },
        async getAuthDetail({ commit, dispatch }, data) {
            const params = { ...data, page: 1, size: 5000 };
            const list = await get(api.agent.authDetail, params);
            commit('getAuthDetail', list || []);
        },
    },
    mutations: {
        resetState(state) {
            Object.assign(state, defaultState());
        },
        changeAgents(state, data) {
            const { agents, totalCount } = data;
            state.total = totalCount;
            state.agents = agents;
        },
        changeDialog(state, data) {
            Object.assign(state.dialog, data);
            if (!data.visible) {
                state.form = defaultForm();
            }
        },
        changeForm(state, data) {
            Object.assign(state.form, data);
        },
        changeSearch(state, data) {
            Object.assign(state.search, data);
        },
        changeAuthDetailDialog(state, data) {
            Object.assign(state.authDetailDialog, data);
        },
        getAuthDetail(state, data) {
            state.authDetail = data;
        },
    },
};

export default moduleAgent;
